import { useState } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import {
  INVENTORY_GUIDE,
  GUIDE_LABELS,
  GuideLang,
} from "../../utils/inventoryGuide.dictionary";

// Static, frontend-only bilingual guide for managing inventory.
const InventoryGuide = () => {
  const [lang, setLang] = useState<GuideLang>("en");
  const labels = GUIDE_LABELS[lang];

  return (
    <Box sx={{ p: 2, maxWidth: 900 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {labels.heading}
        </Typography>
        <Button
          size="small"
          startIcon={<TranslateIcon />}
          variant="outlined"
          onClick={() => setLang((prev) => (prev === "en" ? "hi" : "en"))}
        >
          {labels.toggle}
        </Button>
      </Box>

      <Typography sx={{ color: "#5b6472", mb: 2 }}>{labels.intro}</Typography>

      {INVENTORY_GUIDE.map((section) => (
        <Paper key={section.key} variant="outlined" sx={{ p: 2, mb: 1.5, borderRadius: 2 }}>
          <Typography sx={{ fontWeight: 600, mb: 1 }}>{section.title[lang]}</Typography>
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {section.points[lang].map((point, i) => (
              <li key={i} style={{ color: "#3c4350", marginBottom: 4 }}>
                {point}
              </li>
            ))}
          </ul>
        </Paper>
      ))}
    </Box>
  );
};

export default InventoryGuide;
